import script from "./DetailItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailItem.vue?vue&type=script&setup=true&lang=js"

import "./DetailItem.vue?vue&type=style&index=0&id=c9cffc8a&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9cffc8a"]])

export default __exports__